module.exports = __webpack_public_path__ + "img/discount-offer.9d28207d.png";